import { Color } from "../types";

export const getColor = (color: Color) => {
  const isAppearanceTypes = !isNaN(Number(color))
  if (isAppearanceTypes) {
    switch (color) {
      case '1': return 'var(--colorText)'
      case '2': return 'var(--colorText2)'
      case '3': return 'var(--colorText3)'
      case '4': return 'var(--colorText4)'
    }
  }
  return color
}